import { deleteUselessChars } from '../constants/validityPatterns';

export default function transformPhone(value){
    return value.replace(deleteUselessChars, '');
}